function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { useMemo } from 'react';
import { useApi } from '@deephaven/jsapi-bootstrap';
import { IrisGridModelFactory } from '@deephaven/iris-grid';
import { useLoadTablePlugin } from "./useLoadTablePlugin.js";
/**
 * Hydrate the props for a grid panel
 * @param fetchTable Function to fetch the Table object
 * @param id ID of the dashboard
 * @param metadata Optional serializable metadata for re-fetching the table later
 * @returns Props hydrated for a grid panel
 */
export function useHydrateGrid(fetchTable, id, metadata) {
  var api = useApi();
  var loadPlugin = useLoadTablePlugin();
  var hydratedProps = useMemo(() => ({
    loadPlugin,
    localDashboardId: id,
    makeModel: function () {
      var _makeModel = _asyncToGenerator(function* () {
        var table = yield fetchTable();
        return IrisGridModelFactory.makeModel(api, table);
      });
      function makeModel() {
        return _makeModel.apply(this, arguments);
      }
      return makeModel;
    }(),
    metadata
  }), [api, fetchTable, id, loadPlugin, metadata]);
  return hydratedProps;
}
export default useHydrateGrid;
//# sourceMappingURL=useHydrateGrid.js.map